///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/store/resizable"/>
import * as asyncStore from "Core/Medius.Core.Web/Scripts/Medius/lib/store/async";
import * as local from "Core/Medius.Core.Web/Scripts/Medius/lib/store/local";

const prefix = "Core:resizable-columns",
    store = asyncStore.create(local.localStorageInstance, prefix);

export = store;